<template>
  <span>
    <sidebar-module-info
      has-back-button
      module-name="investments"
      permissions-path="INVESTMENTS"
      ref="sidebarModuleInfo"
      :module-objects="investments"
      :inputs="inputs"
      :filtered-attributes="['id', 'category', 'project_name']"
      :get-object="getInvestmentObject"
      :handle-object-adding="handleInvestmentAdding"
      :handle-object-deleting="deleteInvestment"
      :handle-object-editing="handleInvestmentEditing"
      :init-gets="initGets"
      :toggle-object-adding="toggleInvestmentAdding"
      :zoom-to-object="zoomToInvestment"
      :new-object-payload="{}"
      has-basic-attributes
      :has-assigned-objects="false"
      :name-attribute="
        attrSchemaMetadata[currentLayerSourceName]
          ? attrSchemaMetadata[currentLayerSourceName].attributes_schema.desc_attribute_name
          : ''
      "
    >
      <template v-slot:geometry="scope">
        <sidebar-geometry-input
          v-bind="scope"
          v-model="scope.payload[scope.name]"
          :is-valid.sync="scope.slotsValid[scope.name]"
        />
      </template>
    </sidebar-module-info>
  </span>
</template>

<script>
import { call, get } from 'vuex-pathify';

import SidebarModuleInfo from '@/components/SidebarModuleInfo';
import SidebarGeometryInput from '@/components/SidebarGeometryInput';

export default {
  name: 'Investment',
  components: { SidebarModuleInfo, SidebarGeometryInput },
  computed: {
    investments: get('investments/investments'),
    categories: get('investments/categories'),
    attrSchemaMetadata: get('layers/metadata'),
    currentLayerSourceName: get('layers/currentLayer@data_source_name'),
    inputs() {
      return {
        new: [
          {
            name: 'project_name',
            translationPath: 'sidebar.investmentsModule.projectName',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'category',
            translationPath: 'dialog.category',
            icon: 'mdi-tag-multiple',
            dataType: { name: 'select' },
            items: this.categories,
            itemText: 'name',
            itemValue: 'name',
            rules: [v => !!v || v == '0' || 'rules.required'],
            hasDivider: true,
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hasNameColumn: false,
            cols: '11',
            oneLineInput: false,
            hint: this.$i18n.t('dialog.investmentGeometryInputHint'),
            geometryType: 'Polygon',
            hasAssignGeometry: true,
            assignGeometryType: 'Polygon',
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
        ],
        edit: [
          {
            name: 'project_name',
            translationPath: 'sidebar.investmentsModule.projectName',
            icon: '$label',
            dataType: { name: 'text' },
            rules: [v => !!v || v == '0' || 'rules.required'],
          },
          {
            name: 'category',
            translationPath: 'dialog.category',
            icon: 'mdi-tag-multiple',
            dataType: { name: 'select' },
            items: this.categories,
            itemText: 'name',
            itemValue: 'name',
            rules: [v => !!v || v == '0' || 'rules.required'],
            hasDivider: true,
          },
          {
            name: 'geometry',
            icon: 'mdi-map-marker',
            sectionTitle: 'sidebar.geometrySectionTitle',
            hasNameColumn: false,
            cols: '11',
            hint: this.$i18n.t('dialog.investmentGeometryInputHint'),
            geometryType: 'Polygon',
            hasAssignGeometry: true,
            oneLineInput: false,
            assignGeometryType: 'Polygon',
            drawGeometryText: 'dialog.drawGeometry',
            hasDivider: true,
            assignGeometryText: 'dialog.assignPlot',
          },
        ],
      };
    },
  },
  methods: {
    getCategories: call('investments/getCategories'),
    addInvestment: call('investments/addInvestment'),
    deleteInvestment: call('investments/deleteInvestment'),
    editInvestment: call('investments/editInvestment'),
    getInvestment: call('investments/getInvestment'),
    toggleInvestmentAdding() {
      this.$router.push({
        name: 'investment',
        params: { fid: 'new' },
      });
    },
    zoomToInvestment(layerId, layerGroup, featureId) {
      this.$root.$emit('zoomToFeature', layerId, layerGroup, featureId);
    },
    setFilter(value) {
      this.$root.$emit('setSidebarFilters', { category: value.length < 1 ? ['-'] : value });
    },
    async getInvestmentObject(id) {
      const r = await this.getInvestment(id);
      const object = {
        ...r.properties,
        ...{ id: r.id },
        ...{ geometry: { ...r.geometry, ...{ crs: r.crs } } },
      };
      return object;
    },
    async handleInvestmentAdding(payload) {
      const dateNow = this.$dayjs();
      const dateNowIsoString = dateNow.format('YYYY-MM-DDTHH:mm[:00.000Z]');
      const feature = {
        ...payload,
        ...{ reported_at: dateNowIsoString.slice(0, -1) },
      };
      const r = await this.addInvestment(feature);
      return r.data.data;
    },
    async handleInvestmentEditing(payload) {
      const investment_id = payload.id;
      delete payload.id;
      const feature = {
        ...payload,
      };
      await this.editInvestment({ investment_id, feature });
    },
    async initGets() {
      await this.getCategories();
    },
  },
};
</script>

<style scoped></style>
